import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CommonNotificationService } from '../services/common-notification.service';
import { IStickySnackbarTextSource } from '../widgets/sticky-snackbar/sticky-snackbar.component';
import { LogService, LogEntry } from './log-service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

    constructor(private commonNotificationService: CommonNotificationService, private logService: LogService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // do the request interception work here !
        return next
            .handle(request)
            .do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // DO any response interception work here !
                    this.commonNotificationService.emitLoadingSpinner(false);
                }
            })
            .catch((error: HttpErrorResponse) => {
                let errorMessage: string = '';
                if (error.error instanceof ErrorEvent) {
                    // client-side
                    let errEvent = <ErrorEvent>(error.error);
                    errorMessage = `Error: ${errEvent.message}.`;
                    // log
                    console.error(`ErrorEvent: ${error}.`);
                }
                else {
                    // server-side
                    let httpErrResponse = <HttpErrorResponse>(error);
                    errorMessage = `Error code: ${httpErrResponse.status}.\n\rMessage: ${httpErrResponse.message}.`;
                    if (httpErrResponse.status == 0) // issue with CORS or unknown url
                        errorMessage += `\n\rUrl: ${request.url}.`;
                    this.commonNotificationService.emitStickyFooterText(<IStickySnackbarTextSource>{ text: 'Error on service call: ' + request.url, color: '#ff4081' });
                    setTimeout(() => {
                        this.commonNotificationService.emitSetPreviousText();
                    }, 5000);
                    // log
                    console.error(`HttpErrorResponse: ${error}.`);
                }
                this.commonNotificationService.emitLoadingSpinner(false);

                // alert error
                //window.alert(errorMessage);
                //this.errorDialogService.openDialog({ reason: error && error.error.reason ? error.error.reason : '', status: error.status});

                // save log data
                //var logData = new LogEntry();
                //logData.Message = errorMessage;
                //this.logService.log(logData).subscribe((result: any) => {
                //    console.log("error logged.");
                //}, (error: any) => console.error("log failed." + error));

                return Observable.throw(errorMessage);
            });
    }
}

//// note: todo: create ErrorDialogComponent, ErrorDialogService 
//import { Component, Inject } from '@angular/core';
//import { MAT_DIALOG_DATA } from '@angular/material';
//@Component({
//    selector: 'error-dialog',
//    templateUrl: `<div>
//                    <div>
//                        <p>
//                            Reason: {{data.reason}}
//                        </p>
//                        <p>
//                            Status: {{data.status}}
//                        </p>
//                    </div>
//                </div>`
//})
//export class ErrorDialogComponent {
//    title = 'Angular-Interceptor';
//    constructor( @Inject(MAT_DIALOG_DATA) public data: string) { }
//}

//import { Injectable } from '@angular/core';
//import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ErrorDialogComponent } from './errordialog.component';
//@Injectable()
//export class ErrorDialogService {

//    constructor(public dialog: MatDialog) { }
//    openDialog(data): void {
//        const dialogRef = this.dialog.open(ErrorDialogComponent, {
//            width: '300px',
//            data: data
//        });

//        dialogRef.afterClosed().subscribe(result => {
//            console.log('The dialog was closed');
//            let animal;
//            animal = result;
//        });
//    }
//}



// WEBPACK FOOTER //
// ./src/app/http-communication/http-interceptor.ts